import React from 'react';
import {
    Card,
    CardContent,
} from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";
import EncodeSansBold from '../../assets/fonts/Encode_Sans/EncodeSans-Bold.ttf';

const useStyles = makeStyles((theme) => ({
    mainColumn: {
        display: "flex", flexDirection: "column", justifyContent: "center", height:"100%", alignItems:"center"
    },
    divRow: {
        display: "flex", flexDirection: "row", justifyContent: "center"
    },
    title: {
        color: "#3D4977",
        textAlign: "center",
        fontFamily: "EncodeSansBold",
        fontSize:"16px",
        maxWidth:"70%",
    },
    iconCircle: {
        height: "24px",
        width: "24px",
        borderRadius: "50%",
        display: "inline-block",
    },
    value: {
        fontFamily: "EncodeSansBold",
        fontSize: "27px",
        marginLeft:"10px"
    },
    cardStyle: {
        boxShadow: "2px 2px 2px 2px rgba(0, 0, 0, 0.2)",
        cursor:"pointer",
    },
}));


function DashboardCard(props) {
    const classes = useStyles();
    const title = props.title;
    const value = props.value;
    const cursor = props.cursor;
    const color = props.color;
    const backColor = props.backColor;
    const trend = props.trend;
    return (
        <React.Fragment>
            <Card
                className={classes.cardStyle}
                style={{cursor: {cursor}, width: "176px", height:"176px", backgroundColor: backColor, margin:"8px 8px"}}
            >
                <CardContent style={{height:"100%", padding:"8px"}}>
                    <div className={classes.mainColumn}>

                        <div className={classes.divRow}>
                            {/*<div className={classes.iconCircle} style={{backgroundColor: "#bb0d67"}}>*/}
                            {/*    {trend === 1*/}
                            {/*        ? <ArrowUpwardIcon style={{color: "#fff"}}/>*/}
                            {/*        : <ArrowDownwardIcon style={{color: "#fff"}}/>}*/}
                            {/*</div>*/}
                            <p className={classes.value} style={{color: "#bb0d67"}}>{value}</p>
                        </div>
                        <p className={classes.title}>{title}</p>

                    </div>
                </CardContent>
            </Card>
        </React.Fragment>
    );
}

export default DashboardCard;
